import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Dropdown, Checkbox } from 'semantic-ui-react';
// import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Helmet} from "react-helmet";

// import SelectableIcon from '../../components/icon/SelectableIcon';
// import { skinConcernIcons, allergicIngredientIcons, productTypeUpdated, RESPONSE_STATUS } from '../../utils/constants';
import { RESPONSE_STATUS } from '../../utils/constants';
import './Account.css';
import Api from '../../utils/api';

// const indexMap = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true};
// const indexMapProducts = {1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,11:true,12:true};

class Account extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditingAccount: false,
			firstName: '',
			lastName: '',
			phoneNumber: '',
			email: '',
			newPassword: '',
			confirmedPassword: '',
			isEditingProfile: false,
			regionOptions: [],
			selectedRegionId: null,
			birth: null,
			ethnicityOptions: [],
			selectedEthnicityId: null,
			genderOptions: [],
			selectedGenderId: null,
			isEditingPas: false,
			skinConcerns: [],
            productTypes: [],
            allergicIngredients: [],
			selectedProductMap: {},
            selectedAllergicMap: {},
            selectedSkinConcernMap: {}
		};

		this.selectPasIcon = this.selectPasIcon.bind(this);
        this.deselectPasIcon = this.deselectPasIcon.bind(this);
		this.selectRegion = this.selectRegion.bind(this);
		this.selectEthnicity = this.selectEthnicity.bind(this);
		this.changeGender = this.changeGender.bind(this);
		this.saveAccount = this.saveAccount.bind(this);
		this.saveProfile = this.saveProfile.bind(this);
		this.savePas = this.savePas.bind(this);
	}

	componentWillMount() {
		this.getRegionOptions();
		this.getEthnicityOptions();
		this.getGenderOptions();
		this.getAccountInfo();
	}

	componentDidMount() {
    window.scrollTo(0, 0);
  }


	getRegionOptions() {
        fetch('/api/regions', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
			const regionOptions = responseJson.map(option => {
	            return { value: option.id, text: option.option };
	        });
            this.setState({ regionOptions: regionOptions });
        }).catch(function(err) {
            alert("There is a problem to get the region options. Please try again.");
        });
	}

	getEthnicityOptions() {
        fetch('/api/ethnicities', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
			const ethnicityOptions = responseJson.map(option => {
	            return { value: option.id, text: option.option };
	        });
            this.setState({ ethnicityOptions: ethnicityOptions });
        }).catch(function(err) {
            alert("There is a problem to get the ethnicity options. Please try again.");
        });
	}

	getGenderOptions() {
        fetch('/api/genders', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ genderOptions: responseJson	 });
        }).catch(function(err) {
            alert("There is a problem to get the gender options. Please try again.");
        });
	}

	getAccountInfo() {
		const userId = localStorage.getItem("user_id");
        fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ firstName: responseJson.firstName, lastName: responseJson.lastName,
                phoneNumber: responseJson.phoneNumber, email: responseJson.email,
                selectedRegionId: responseJson.region && responseJson.region.id,
				selectedEthnicityId: responseJson.ethnicity && responseJson.ethnicity.id,
                selectedGenderId: responseJson.gender && responseJson.gender.id,
				birth: responseJson.birth && moment(responseJson.birth),
			 	skinConcerns: responseJson.skinConcerns, productTypes: responseJson.productTypes,
				allergicIngredients: responseJson.allergicIngredients });
            this.state.productTypes.forEach((productType, index, arr) => {
            	if(productType["id"] === 9 || productType["id"] === 10) arr.splice(index, 1);
            });
            let indexNine = this.state.productTypes.indexOf(9);
            let indexTen = this.state.productTypes.indexOf(10);
            if (indexNine !== -1) this.state.productTypes.splice(indexNine, 1);
            if (indexTen !== -1) this.state.productTypes.splice(indexTen, 1);
            if (9 in this.state.selectedProductMap) delete this.state.selectedProductMap[9];
            if (10 in this.state.selectedProductMap) delete this.state.selectedProductMap[10];
        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
	}

	handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

	handleDateChange = (date) => {
		this.setState({ birth: date });
	}

	selectRegion(event, data) {
		this.setState({ selectedRegionId: data.value });
	}

	selectEthnicity(event, data) {
		this.setState({ selectedEthnicityId: data.value });
	}

	changeGender(event, data) {
		this.setState({ selectedGenderId: data.value });
	}

	selectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        const index = splits[1];
        if (type === 'product') {
            let selectedProductMap = this.state.selectedProductMap;
            selectedProductMap[index] = true;
            this.setState({ selectedProductMap: selectedProductMap });
        } else if (type === 'allergic') {
            let selectedAllergicMap = this.state.selectedAllergicMap;
            selectedAllergicMap[index] = true;
            this.setState({ selectedAllergicMap: selectedAllergicMap });
        } else if (type === 'skinconcern') {
            let selectedSkinConcernMap = this.state.selectedSkinConcernMap;
            selectedSkinConcernMap[index] = true;
            this.setState({ selectedSkinConcernMap: selectedSkinConcernMap });
        }
    }

    deselectPasIcon(id) {
        const splits = id.split("-");
        const type = splits[0];
        const index = splits[1];
        if (type === 'product') {
            let selectedProductMap = this.state.selectedProductMap;
            if (index in selectedProductMap) {
                delete selectedProductMap[index];
            }
            this.setState({ selectedProductMap: selectedProductMap });
        } else if (type === 'allergic') {
            let selectedAllergicMap = this.state.selectedAllergicMap;
            if (index in selectedAllergicMap) {
                delete selectedAllergicMap[index];
            }
            this.setState({ selectedAllergicMap: selectedAllergicMap });
        } else if (type === 'skinconcern') {
            let selectedSkinConcernMap = this.state.selectedSkinConcernMap;
            if (index in selectedSkinConcernMap) {
                delete selectedSkinConcernMap[index];
            }
            this.setState({ selectedSkinConcernMap: selectedSkinConcernMap });
        }
    }

	saveAccount() {
		const firstName = this.state.firstName;
		const lastName = this.state.lastName;
		const phoneNumber = this.state.phoneNumber;
		const email = this.state.email;
		const newPassword = this.state.newPassword;
		const confirmedPassword = this.state.confirmedPassword;

		if (!firstName) {
			alert("First name cannot be empty.");
			return;
		}
		if (!lastName) {
			alert("Last name cannot be empty.");
			return;
		}
		if (!phoneNumber) {
			alert("Phone number cannot be empty.");
			return;
		}
		if ((newPassword || confirmedPassword) && newPassword !== confirmedPassword) {
			alert("Password doesn't match.");
			return;
		}

		const promise1 = new Promise((resolve, reject) => {
			fetch("/api/account", {
	            method: 'PATCH',
	            headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': Api.auth_tokenManager()
				},
				body: JSON.stringify({
					email: email,
					firstName: firstName,
					lastName: lastName
				})
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject();
	            }
	        });
		});
		const promise2 = new Promise((resolve, reject) => {
			fetch("/api/user-profiles", {
				method: 'PATCH',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': Api.auth_tokenManager()
				},
				body: JSON.stringify({
					userId: localStorage.getItem("user_id"),
					phoneNumber: phoneNumber
				})
			}).then(response => {
				if (response.status === RESPONSE_STATUS.OK) {
					resolve();
				} else {
					reject();
				}
			});
		});
		const promise3 = new Promise((resolve, reject) => {
			if (!newPassword && !confirmedPassword) {
				resolve();
			} else {
				fetch("/api/account/password", {
		            method: 'POST',
		            headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'x-auth-token': Api.auth_tokenManager()
					},
					body: JSON.stringify({
						key: email,
						newPassword: newPassword
					})
		        }).then(response => {
		            if (response.status === RESPONSE_STATUS.OK) {
		                return response.json();
		            } else {
		                reject();
		            }
		        }).then(json => {
                    if (json) {
                        localStorage.setItem('auth_token', json.token.token);
                        localStorage.setItem('user_id', json.userId);
                        localStorage.setItem('user_firstname', json.firstName);
						resolve();
                    } else {
						reject();
					}
                });
			}
		});

		Promise.all([promise1, promise2, promise3]).then(res => {
			this.setState({ isEditingAccount: false });
		}).catch(err => {
			alert("There is a problem to update the account. Please try again.");
		});
	}

	saveProfile() {
		fetch("/api/user-profiles", {
			method: 'PATCH',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
			},
			body: JSON.stringify({
				userId: localStorage.getItem("user_id"),
				regionId: this.state.selectedRegionId,
				ethnicityId: this.state.selectedEthnicityId,
				genderId: this.state.selectedGenderId,
				birth: this.state.birth
			})
		}).then(response => {
			if (response.status === RESPONSE_STATUS.OK) {
				this.setState({ isEditingProfile: false });
			} else {
				alert("There is a problem to update the profile. Please try again.");
			}
		});
	}

	savePas() {
		const userId = localStorage.getItem("user_id");
		const selectedProductMap = this.state.selectedProductMap;
        const selectedProductIndices = Object.keys(selectedProductMap);
        if (selectedProductIndices.length === 0) {
            alert("You must select at least one product option.");
            return;
        }
		const selectedAllergicMap = this.state.selectedAllergicMap;
        const selectedAllergicIndices = Object.keys(selectedAllergicMap);
        if (selectedAllergicIndices.length === 0) {
            alert("You must select at least one allergic option.");
            return;
        }
		const selectedSkinConcernMap = this.state.selectedSkinConcernMap;
        const selectedSkinConcernIndices = Object.keys(selectedSkinConcernMap);
        if (selectedSkinConcernIndices.length === 0) {
            alert("You must select at least one skin concern option.");
            return;
        }

		const promise1 = new Promise((resolve, reject) => {
			fetch("/api/user-product-types?user-id=" + userId + "&options=" + selectedProductIndices, {
	            method: 'POST',
	            headers: { 'x-auth-token': Api.auth_tokenManager() }
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject("There is a problem to save the products. Please try again.");
	            }
	        });
		});
		const promise2 = new Promise((resolve, reject) => {
			fetch("/api/user-allergic-ingredients?user-id=" + userId + "&options=" + selectedAllergicIndices, {
	            method: 'POST',
	            headers: { 'x-auth-token': Api.auth_tokenManager() }
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject("There is a problem to save the allergies. Please try again.");
	            }
	        });
		});
		const promise3 = new Promise((resolve, reject) => {
			fetch("/api/user-skin-concerns?user-id=" + userId + "&options=" + selectedSkinConcernIndices, {
	            method: 'POST',
	            headers: { 'x-auth-token': Api.auth_tokenManager() }
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject("There is a problem to save the skin concerns. Please try again.");
	            }
	        });
		});

		Promise.all([promise1, promise2, promise3]).then(res => {
			this.setState({ isEditingPas: false });
			this.getAccountInfo();
		}).catch(err => {
			alert(err);
		});
	}

	render() {
		const isEditingAccount = this.state.isEditingAccount;
		const isEditingProfile = this.state.isEditingProfile;

        const regionOptions = this.state.regionOptions;
        const ethnicityOptions = this.state.ethnicityOptions;
        const genderOptions = this.state.genderOptions.map(option => {
            return <Checkbox key={ option.id } radio label={ option.option } name="genderOptionGroup" value={ option.id }
                checked={ this.state.selectedGenderId === option.id } disabled={ !isEditingProfile }
				onChange={ this.changeGender } />;
        });

		// const isEditingPas = this.state.isEditingPas;

  //       let selectedProductMap = {};
  //       let deselectedProductMap = Object.assign({}, indexMapProducts);
		// const productTypeIndice = this.state.productTypes.map(product => product.id);
  //       productTypeIndice.forEach(index => {
  //           if (index in deselectedProductMap) {
  //               delete deselectedProductMap[index];
  //           }
  //           selectedProductMap[index] = true;
  //       });
  //       const selectedProductOptions = productTypeIndice.sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/prodcats/" + productTypeUpdated[index - 1] } selectable={ isEditingPas }
  //                       selected={ true } style={{ width: '30px', height: '30px' }} id={ "product-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ productTypeUpdated[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });
  //       const deselectedProductOptions = Object.keys(deselectedProductMap).sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/prodcats/" + productTypeUpdated[index - 1] } selectable={ isEditingPas }
  //                       selected={ false } style={{ width: '30px', height: '30px' }} id={ "product-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ productTypeUpdated[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });

  //       let selectedAllergicMap = {};
  //       let deselectedAllergicMap = Object.assign({}, indexMap);
		// const allergicIngredientIndice = this.state.allergicIngredients.map(ingredient => ingredient.id);
  //       allergicIngredientIndice.forEach(index => {
  //           if (index in deselectedAllergicMap) {
  //               delete deselectedAllergicMap[index];
  //           }
  //           selectedAllergicMap[index] = true;
  //       });
  //       const selectedAllergicOptions = allergicIngredientIndice.sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/allergies/" + allergicIngredientIcons[index - 1] } selectable={ isEditingPas }
  //                       selected={ true } style={{ width: '30px', height: '30px' }} id={ "allergic-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ allergicIngredientIcons[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });
  //       const deselectedAllergicOptions = Object.keys(deselectedAllergicMap).sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/allergies/" + allergicIngredientIcons[index - 1] } selectable={ isEditingPas }
  //                       selected={ false } style={{ width: '30px', height: '30px' }} id={ "allergic-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ allergicIngredientIcons[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });

  //       let selectedSkinConcernMap = {};
  //       let deselectedSkinConcernMap = Object.assign({}, indexMap);
		// const skinConcernIndice = this.state.skinConcerns.map(skinConcern => skinConcern.id);
  //       skinConcernIndice.forEach(index => {
  //           if (index in deselectedSkinConcernMap) {
  //               delete deselectedSkinConcernMap[index];
  //           }
  //           selectedSkinConcernMap[index] = true;
  //       });
  //       const selectedSkinConcernOptions = skinConcernIndice.sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/skincons/" + skinConcernIcons[index - 1] } selectable={ isEditingPas }
  //                       selected={ true } style={{ width: '30px', height: '30px' }} id={ "skinconcern-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ skinConcernIcons[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });
  //       const deselectedSkinConcernOptions = Object.keys(deselectedSkinConcernMap).sort().map(index => {
  //           return (
  //               <div key={ index } className="option">
  //                   <SelectableIcon path={ "/images/onboarding/skincons/" + skinConcernIcons[index - 1] } selectable={ isEditingPas }
  //                       selected={ false } style={{ width: '30px', height: '30px' }} id={ "skinconcern-" + index }
  //                       onSelected={ this.selectPasIcon } onDeselected={ this.deselectPasIcon } />
  //                   <div className="option-label">{ skinConcernIcons[index - 1].replace(".svg", "").replace("-", " ") }</div>
  //               </div>
  //           );
  //       });

		return (
			<div className="account">
				<Helmet>
                    <title>Account - HelloAva</title>
                </Helmet>
				<div className="account-section section">
					<div className="row">
						<div className="section-header">Account</div>
						{
							isEditingAccount ?
							<div className="section-edit" onClick={ this.saveAccount }>Save</div>
							:
							<div className="section-edit" onClick={() => this.setState({ isEditingAccount: true })}>Edit</div>
						}
					</div>
					<div className="row">
						<div className="column">
							<div className="column-header">FIRST NAME</div>
							<input type="text" name="firstName" value={ this.state.firstName } onChange={this.handleChange}
							 	disabled={ !isEditingAccount } />
						</div>
						<div className="column">
							<div className="column-header">LAST NAME</div>
							<input type="text" name="lastName" value={ this.state.lastName } onChange={this.handleChange}
								disabled={ !isEditingAccount } />
						</div>
					</div>
					<div className="row">
						<div className="column">
							<div className="column-header">PHONE</div>
							<input type="text" name="phoneNumber" value={ this.state.phoneNumber } onChange={this.handleChange}
								disabled={ !isEditingAccount } />
						</div>
						<div className="column">
							<div className="column-header">EMAIL</div>
							<input type="text" name="email" value={ this.state.email } onChange={this.handleChange} disabled={ true } />
						</div>
					</div>
					<div className="row">
						<div className="column">
							<div className="column-header">NEW PASSWORD</div>
							<input type="password" name="newPassword" value={ this.state.newPassword } onChange={this.handleChange}
								disabled={ !isEditingAccount } />
						</div>
						<div className="column">
							<div className="column-header">CONFIRM PASSWORD</div>
							<input type="password" name="confirmedPassword" value={ this.state.confirmedPassword } onChange={this.handleChange}
								disabled={ !isEditingAccount } />
						</div>
					</div>
				</div>
				<hr />
				<div className="profile-section section">
					<div className="row">
						<div className="section-header">Profile</div>
						{
							isEditingProfile ?
							<div className="section-edit" onClick={ this.saveProfile }>Save</div>
							:
							<div className="section-edit" onClick={() => this.setState({ isEditingProfile: true })}>Edit</div>
						}
					</div>
					<div className="row">
						<div className="column">
							<div className="column-header">REGION</div>
							<Dropdown selection options={ regionOptions } value={ this.state.selectedRegionId }
								disabled={ !isEditingProfile } onChange={ this.selectRegion } />
						</div>
						{
							/*
							<div className="column">
								<div className="column-header">DATE OF BIRTH</div>
								<div className="datepicker">
									<DatePicker disabled={ !isEditingProfile }
										selected={ this.state.birth }
										onChange={ this.handleDateChange }
									/>
								</div>
							</div>*/
						}
					</div>
					<div className="row">
						<div className="column">
							<div className="column-header">ETHNICITY</div>
							<Dropdown selection options={ ethnicityOptions } value={ this.state.selectedEthnicityId }
								disabled={ !isEditingProfile } onChange={ this.selectEthnicity } />
						</div>
					</div>
					<div className="row">
						<div className="column full-width">
							<div className="column-header">GENDER</div>
                            <div className="row">{ genderOptions }</div>
						</div>
					</div>
					{/* <div className="row">
						<div className="column">
							<div className="column-header">PHOTO</div>
						</div>
					</div> */}
				</div>

			</div>
		);
	}
}

export default withRouter(Account);



// WEBPACK FOOTER //
// ./src/views/account/Account.js